import { render, staticRenderFns } from "./ProblemRecord copy.vue?vue&type=template&id=07ece083&scoped=true"
import script from "./ProblemRecord copy.vue?vue&type=script&lang=js"
export * from "./ProblemRecord copy.vue?vue&type=script&lang=js"
import style0 from "./ProblemRecord copy.vue?vue&type=style&index=0&id=07ece083&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ece083",
  null
  
)

export default component.exports